import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class DonationService {
	
	public static donationGetByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Donation/getdonationsbyuser', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

}